import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "@/lib/api";

// Handles the OAuth return: exchanges session_id for a session cookie, then redirects.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/admin/login", { replace: true });
        return;
      }
      try {
        await authApi.post("/auth/session", { session_id: sessionId });
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true });
      } catch (e) {
        navigate("/admin/login", { replace: true });
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A2540] text-white">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-white/30 border-t-white rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-white/80">Signing you in…</p>
      </div>
    </div>
  );
}
